import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../../context/auth';
import FatalError from '../../components/FatalError';

function RequireAuth({ children, admin, theme }) {
  const auth = useAuth();

  if (!auth.user) {
    return <Navigate to="/login" />;
  }

  if (admin && !auth.user.rights.admin) {
    return <FatalError error="Vous n'avait pas les droits nécessaires pour accéder à cette ressource." hideRefresh />;
  }

  if (theme && !auth.user.rights.theme) {
    return <FatalError error="Vous n'avait pas les droits nécessaires pour accéder à cette ressource." hideRefresh />;
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.object,
  admin: PropTypes.bool,
  theme: PropTypes.bool,
};

RequireAuth.defaultProps = {
  children: {},
  admin: false,
  theme: false,
};

export default RequireAuth;
